import { render, staticRenderFns } from "./conversation-summary.vue?vue&type=template&id=8d468bca&scoped=true&"
import script from "./conversation-summary.vue?vue&type=script&lang=js&"
export * from "./conversation-summary.vue?vue&type=script&lang=js&"
import style0 from "./conversation-summary.vue?vue&type=style&index=0&id=8d468bca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d468bca",
  null
  
)

export default component.exports